import { z } from "zod"
import { DurationSchema, TimelineSchema, PositionSchema } from "./timing"

export const TextStyleSchema = z.object({
  backgroundColor: z.string().default("rgba(255,255,255,0.95)"),
  fontFamily: z.string().default("Montserrat"),
  fontWeight: z.string().default("900"),
  fontColor: z.string().default("#000000"),
  fontSize: z.number().min(12).max(120).default(26),
  italic: z.boolean().default(false),
  borderRadius: z.number().default(4),
  padding: z.number().default(8),
  textAlign: z.string().default("center"),
  borderColor: z.string().nullable().default(null),
  borderWidth: z.number().default(0),
})

export const HookTextElementSchema = z.object({
  id: z.string(),
  text: z.string(),
  duration: DurationSchema,
  timeline: TimelineSchema,
  color: z.number().default(0),
})

export const HookContentSchema = z.object({
  id: z.string(),
  textElements: z.array(HookTextElementSchema),
  textOverlayType: z.enum(["paragraph", "title", "word-by-word"]).default("paragraph"),
  textStyle: TextStyleSchema.default({}),
  scale: z.number().default(1.0),
  rotation: z.number().default(0),
  duration: DurationSchema,
  timeline: TimelineSchema,
})

export const HookSegmentSchema = z.object({
  id: z.string(),
  contentType: z.literal("HookTextOverlay"),
  duration: DurationSchema,
  timeline: TimelineSchema,
  content: HookContentSchema,
  position: PositionSchema.default({ type: "CPct", xPct: 0, yPct: -0.6, wPct: 0.9, hPct: 0.15 }),
})

export type TextStyle = z.infer<typeof TextStyleSchema>
export type HookTextElement = z.infer<typeof HookTextElementSchema>
/** @deprecated Use HookTextElement instead */
export type TextElement = HookTextElement
export type HookContent = z.infer<typeof HookContentSchema>
export type HookSegment = z.infer<typeof HookSegmentSchema>
